import { useWatchlist } from './useWatchlist';
import { WatchlistEntities } from './watchlist-types';

export const entityProxy = (e: WatchlistEntities) =>
  new Proxy(
    { ...e, isLoading: true },
    {
      get: function async(
        target: WatchlistEntities,
        prop: keyof WatchlistEntities
      ) {
        if (!(prop in target) && prop !== 'tag') {
          useWatchlist.getState().getEntity(target.tag);
          target[prop] = undefined;
        }
        return target[prop];
      },
    }
  );
